import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { PaymentRefundNormalizedData } from '../types';
import { PaymentRefundDetailsWithFXCard } from './PaymentRefundDetailsWithFXCard';
import { PaymentRefundDetailsCard } from './PaymentRefundDetailsCard';

interface PaymentRefundDetailsProps extends PaymentRefundNormalizedData {
    isRefundWithFX: boolean;
}

export const PaymentRefundDetails = (data: PaymentRefundDetailsProps) => {
    const {
        isRefundWithFX,
        refundableValue,
        chargeAmount,
        propertyCurrencyChargeAmount,
        propertyCurrencyRefundAmount,
        chargeConversionRate,
        refundConversionRate,
    } = data;

    return isRefundWithFX ? (
        <Stack distribution="stretch" spacing="200">
            <PaymentRefundDetailsWithFXCard
                titleTextKey={TextKey.PaymentRefundToProcess}
                outline={false}
                variant="highlighted"
                chargeCurrencyAmount={{ value: refundableValue, currencyCode: chargeAmount.currencyCode }}
                propertyCurrencyAmount={{
                    value: propertyCurrencyRefundAmount.value,
                    currencyCode: propertyCurrencyRefundAmount.currencyCode,
                }}
                conversionRateTextKey={TextKey.PaymentRefundConversionRateToday}
                conversionRate={refundConversionRate}
            />
            <PaymentRefundDetailsWithFXCard
                titleTextKey={TextKey.PaymentRefundOriginalCharge}
                chargeCurrencyAmount={{ value: chargeAmount.value, currencyCode: chargeAmount.currencyCode }}
                propertyCurrencyAmount={{
                    value: propertyCurrencyChargeAmount.value,
                    currencyCode: propertyCurrencyChargeAmount.currencyCode,
                }}
                conversionRateTextKey={TextKey.PaymentRefundAppliedConversionRate}
                conversionRate={chargeConversionRate}
            />
        </Stack>
    ) : (
        <Stack distribution="stretch" spacing="200">
            <PaymentRefundDetailsCard
                outline={false}
                variant="highlighted"
                amount={{ value: refundableValue, currencyCode: chargeAmount.currencyCode }}
                titleTextKey={TextKey.PaymentRefundToProcess}
            />
            <PaymentRefundDetailsCard
                amount={{ value: chargeAmount.value, currencyCode: chargeAmount.currencyCode }}
                titleTextKey={TextKey.PaymentRefundChargedAmount}
            />
        </Stack>
    );
};
